export class ProductMediaLightbox extends window.BAO.CustomElement({
  SuperClass: HTMLDialogElement,
}) {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.handleTrigger = this.handleTrigger.bind(this)
    this.handleClose = this.handleClose.bind(this)

    if (window.BAO.MediaBreakpoints.isMd) {
      this.externalEls?.trigger?.elements.forEach((triggerEl) => {
        this.listeners.add(triggerEl, 'click', this.handleTrigger)
      })
    }

    this.els?.body?.element.addEventListener('click', this.handleClose)
    this.els?.close?.elements.forEach((close) => {
      this.listeners.add(close, 'click', this.handleClose)
    })

    this.listeners.add(document.documentElement, 'keydown', (e) => {
      if (e.key === 'Escape') {
        this.handleClose()
      }
    })
  }

  handleTrigger (event) {
    const trigger = event.currentTarget
    if (!trigger) return

    this.showModal()

    document.body.classList.toggle('util-SiteOverflowed', true)

    requestAnimationFrame(() => this.handleImageView(trigger))
  }

  handleImageView (triggerEl) {
    const index = triggerEl?.dataset?.index

    const target = this.els.image.elements.find(
      (imageEl) => imageEl.dataset.index === index,
    )

    if (target) {
      target.scrollIntoView({ behavior: 'instant', block: 'start' })
    }
  }

  handleClose () {
    this.close()

    document.body.classList.toggle('util-SiteOverflowed', false)

    setTimeout(() => {
      this.els?.body?.element?.scrollTo({ top: 0, behavior: 'auto' })
    }, 500)
  }
}

if (!customElements.get('product-media-lightbox')) {
  customElements.define('product-media-lightbox', ProductMediaLightbox, {
    extends: 'dialog',
  })
}
